import { Money } from '@pylot-data/fwrdschema'
import TabbyPromoWidget from '../TabbyPromo/TabbyPromo'
import TamaraPromoWidget from '../TamaraPromo/TamaraPromo'
import s from './PaymentOptionsWidget.module.scss'
import { formatPrice } from '@corratech/pylot-price'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

type Props = {
    readonly price: Money
}

export default function PaymentOptionsWidget({ price }: Props) {
    const { t } = useTranslation('pdp')
    const { locale = 'en' } = useRouter()

    const installmentPrice = formatPrice(
        {
            value: (price.value || 0) / 4,
            currency: price.currency
        },
        locale
    )

    return (
        <div className={s['payment-options-wrapper']}>
            <p>
                {t('or 4 payments of')} <strong>{installmentPrice}</strong>{' '}
                {t('with')}
            </p>
            <TabbyPromoWidget price={price} />
            <TamaraPromoWidget price={price} />
        </div>
    )
}
